import ApiResourceManager from '../ApiResourceManager';

// The platform agent's chats (docs/platform-agent/contracts.md §6), on the agent itself (VITE_PLATFORM_AGENT_URL):
// use with useApiClient({ baseUrl: import.meta.env.VITE_PLATFORM_AGENT_URL, autoLogOut: false }). `headers` are the
// ones the panel's chat sends the agent (platformAgentHeaders: the on-behalf-of headers and the language), so the
// agent sees the same person and restaurant as in the chat.
export default class PlatformAgentChatsManager extends ApiResourceManager {
  // The chats on a restaurant (`subject` is `type:id`), newest first: `{ chats, next_cursor }`.
  list = ({ subject, cursor = null, limit }, headers = {}) =>
    this.request({
      method: 'GET',
      url: '/chats',
      params: { subject, ...(cursor ? { cursor } : {}), ...(limit ? { limit } : {}) },
      headers,
    });

  // A new chat (an eve session) on the restaurant of the headers: `{ chat }`.
  create = (headers = {}) =>
    this.request({
      method: 'POST',
      url: '/chats',
      data: {},
      headers,
    });

  // One chat with its summary and history: `{ chat, events, notices }`.
  get = (id, headers = {}) =>
    this.request({
      method: 'GET',
      url: `/chats/${encodeURIComponent(id)}`,
      headers,
    });

  // The person has seen every answer in the chat so far: `{ unread: 0 }`.
  markRead = (id, headers = {}) =>
    this.request({
      method: 'POST',
      url: `/chats/${encodeURIComponent(id)}/read`,
      data: {},
      headers,
    });

  // How many of the agent's answers on a restaurant (`subject` is `type:id`) the person hasn't seen yet, for the
  // button's news: `{ unread, chats: [{ id, unread }] }`.
  unread = ({ subject }, headers = {}) =>
    this.request({
      method: 'GET',
      url: '/chats/unread',
      params: { subject },
      headers,
    });

  // Helpful? (D10) on an answer (its eve message id) or a card (its change set id): `{ recorded: true }`. A second
  // vote replaces the first; `helpful: null` takes it back (B36).
  feedback = (id, { messageId, helpful }, headers = {}) =>
    this.request({
      method: 'POST',
      url: `/chats/${encodeURIComponent(id)}/feedback`,
      data: { message_id: messageId, helpful },
      headers,
    });
}
